import { useMutation } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

export type RefreshAccountBalanceResponse = {
  available_balance: number
  current_balance: number
}

type MutationFnParams = {
  accountId: string
}

export function useRefreshAccountBalance() {
  return useMutation<RefreshAccountBalanceResponse, unknown, MutationFnParams>({
    mutationFn: async ({ accountId }) => {
      const response = await fetcher(
        "/Account/RefreshBalance",
        {
          method: "POST",
          body: JSON.stringify({
            AccountId: accountId,
          }),
        },
        {
          useAccessToken: true,
        }
      )

      return await response.json()
    },
  })
}
